import { API } from '..';

// Cab+ Pro (Phase 3): gói VIP không quảng cáo + xem offline. Mua bằng Ca ví.
export interface CabPlusPlan {
  months: number;
  discountPercent: number;
  pricePerMonthCa: number; // giá/tháng sau giảm
  totalPriceCa: number; // tổng sau giảm
  originalTotalCa: number; // tổng chưa giảm (gạch ngang)
}
export type CabPlusTier = 'lite' | 'plus' | 'pro';
export interface CabPlusTierBenefit {
  aiTurns: number;
  datingRequests: number;
  avatarRarity: string;
}
export interface CabPlusStatus {
  isPremium: boolean;
  tier?: CabPlusTier | null; // bậc đang hiệu lực (isPremium/premiumUntil chỉ nói về Pro)
  tierUntil?: string | null;
  litePriceCa?: number;
  plusPriceCa?: number;
  benefits?: Partial<Record<CabPlusTier, CabPlusTierBenefit>>;
  premiumUntil?: string | null;
  pricePerMonthCa: number;
  balanceCa: number;
  plans?: CabPlusPlan[]; // gói tháng + ưu đãi giảm giá mua nhiều tháng
}

export const getCabPlusStatus = () =>
  API.get<CabPlusStatus>('/v1/payment-service/cab-plus/status').then((r) => r.data);

export interface BuyCabPlusParams {
  tier: CabPlusTier;
  months?: number; // chỉ Pro chọn tháng; Lite/Plus luôn 1 tháng
  refUserId?: string;
}

export const buyCabPlus = ({ tier, months = 1, refUserId }: BuyCabPlusParams) =>
  API.post<CabPlusStatus>(
    `/v1/payment-service/cab-plus/buy?months=${months}&tier=${tier}${refUserId ? `&refUserId=${encodeURIComponent(refUserId)}` : ''}`
  ).then((r) => r.data);
